const TraceabilityTemporary = () => {
  return (
    <iframe
      data-testid="traceability-temp-frame"
      src={`https://dev.ceritaproduk.id`}
      title="Traceability"
      style={{
        width: '100%',
        height: '100vh',
        border: 'none',
      }}
    />
  )
}

export default TraceabilityTemporary
